import { render, staticRenderFns } from "./StepCoWorkers.vue?vue&type=template&id=c5325070&"
import script from "./StepCoWorkers.vue?vue&type=script&lang=js&"
export * from "./StepCoWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports